export default {"src":"/_next/static/media/sun-01.5c0932a5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};